import mapKnownValues from "@/utils/mapKnownValues";

export enum CreditProgramType {
  temporary = "TEMPORARY",
  permanent = "PERMANENT"
}

export enum CreditProgramSubType {
  sceSession = "SESSION",
  sceInterval = "INTERVAL"
}

export const CreditProgramSCE = "SCE";

export type CreditProgramAPIResponse = {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  status: "ARCHIVED" | "ACTIVE";
  programType: CreditProgramType;
  programData: {
    programKeys: string[];
  } | null;
  programSubType: typeof CreditProgramSCE | null;
};

export default class CreditProgram {
  id = "";
  name = "";
  description = "";
  createdAt = new Date();
  status = "ACTIVE";
  programType: CreditProgramType = CreditProgramType.temporary;
  programSubType: typeof CreditProgramSCE | null = null;
  programData = {
    programKeys: [] as string[]
  };

  constructor(params: Partial<CreditProgram> = {}) {
    mapKnownValues(this, params);
  }

  toJson() {
    // Program data is either null, or it has keys
    const programData = this.programData.programKeys.length
      ? {
          programKeys: this.programData.programKeys
        }
      : null;
    return {
      ...this,
      programData
    };
  }

  static fromAPI(response: CreditProgramAPIResponse) {
    return new CreditProgram({
      ...response,
      createdAt: new Date(response.createdAt),
      programData: {
        ...response.programData,
        programKeys: response.programData?.programKeys || []
      }
    });
  }
}
